import { useDispatch } from "react-redux";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IRootState } from "../redux/reducers";

export type AppDispatch = ThunkDispatch<IRootState, unknown, AnyAction>;

/**
 * `useDispatch` typed to accept thunks as well as plain actions. The untyped
 * `useDispatch()` resolves to `Dispatch<AnyAction>` and rejects thunk
 * functions.
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
